import { Translation } from "../i18n-types";

const bg: Translation = {
    "state-is-required": "State is required field.",
    description: {
        "show-more": "Покажи повече",
        "show-less": "Покажи по-малко"
    },
    footer: {
        "why-shop-with-us": "Защо, според вас, пазарувате от нас?",
        "heureka-image-url": "/footer/img/bg/comparator.png",
        benefits: {
            first: "супер бърза доставка",
            second: "много бързо и надеждно обслужване",
            third: "приятелски подход за поддръжка на клиенти"
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffoxigy.bg&tabs&width=314&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
            "facebook-page-url": "https://www.facebook.com/foxigy.bg",
            "instagram-page-url": "https://www.instagram.com/foxigy.bg/",
            "youtube-page-url": "https://www.youtube.com/channel/UCBxow9jz4MPZiJb5-UJTltQ"
        },
        "your-foxigy-image-link": "/footer/img/bg/your-foxigy.png"
    }
};

export default bg;
